(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abz-craft-intro"] && !Shopify.designMode) return;
  try {
    
class AbzCraftIntro extends HTMLElement{
connectedCallback(){
if(this.initialized)return;
this.initialized=true;
this.heading=this.querySelector('.abz-craft-title');
if(!this.heading)return;
if(window.matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver' in window))return;
this.classList.add('is-armed');
this.observer=new IntersectionObserver(entries=>{
if(entries.some(entry=>entry.isIntersecting)){
this.frame=requestAnimationFrame(()=>{this.frame=requestAnimationFrame(()=>this.classList.add('is-revealed'));});
this.observer.disconnect();
}
},{threshold:.12,rootMargin:'0px 0px -12% 0px'});
this.observer.observe(this.heading);
}
disconnectedCallback(){this.observer?.disconnect();if(this.frame)cancelAnimationFrame(this.frame);this.classList.remove('is-armed','is-revealed');this.initialized=false;}
}
if(!customElements.get('abz-craft-intro'))customElements.define('abz-craft-intro',AbzCraftIntro);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["abz-project-portfolio"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('abz-project-portfolio')) {
    customElements.define('abz-project-portfolio', class extends HTMLElement {
      connectedCallback() {
        if (this.filterController) return;
        this.filterController = new AbortController();
        this.cards = Array.from(this.querySelectorAll('[data-project-card]'));
        this.selected = { city: '*', type: '*' };
        this.grid = this.querySelector('.ed-project-grid');
        this.filters = this.querySelector('.abz-project-filters');
        this.status = this.querySelector('[data-result-count]');
        this.empty = this.querySelector('.abz-project-filter-empty');
        this.reset = this.querySelector('[data-filter-reset]');
        const dimensions = { city: 'city', type: 'projectType' };
        Object.entries(dimensions).forEach(([key, attribute]) => {
          const row = this.querySelector('[data-filter-options="' + key + '"]');
          row.replaceChildren();
          const values = [...new Set(this.cards.map(card => card.dataset[attribute]).filter(Boolean))].sort((a, b) => a.localeCompare(b));
          const perLine = Math.max(1, Math.ceil((values.length + 1) / 2));
          let line;
          ['*', ...values].forEach((value, index) => {
            if (index % perLine === 0) {
              line = document.createElement('div');
              line.className = 'abz-project-filter-line';
              row.append(line);
            }
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'abz-project-filter-button';
            button.dataset.filterKey = key;
            button.dataset.filterValue = value;
            button.textContent = value === '*' ? this.dataset.allLabel : value;
            button.setAttribute('aria-controls', this.grid.id);
            button.setAttribute('aria-pressed', String(value === '*'));
            if (key === 'city' && value !== '*') {
              button.title = [...new Set(this.cards.filter(card => card.dataset.city === value).map(card => card.dataset.cityName).filter(Boolean))].join(', ');
            }
            line.append(button);
          });
        });
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-filter-key')) {
            this.selected[button.dataset.filterKey] = button.dataset.filterValue;
          } else if (button.hasAttribute('data-filter-reset') || button.hasAttribute('data-show-all')) {
            this.selected = { city: '*', type: '*' };
            this.querySelector('[data-filter-key="city"]').focus({ preventScroll: true });
          } else return;
          this.applyFilters();
        }, { signal: this.filterController.signal });
        this.addEventListener('shopify:block:select', () => {
          this.selected = { city: '*', type: '*' };
          this.applyFilters();
        }, { signal: this.filterController.signal });
        this.applyFilters();
        this.filters.hidden = this.cards.length === 0;
      }
      applyFilters() {
        let shown = 0;
        this.cards.forEach(card => {
          const matches = (this.selected.city === '*' || card.dataset.city === this.selected.city) && (this.selected.type === '*' || card.dataset.projectType === this.selected.type);
          card.hidden = !matches;
          if (matches) shown += 1;
        });
        this.querySelectorAll('[data-filter-key]').forEach(button => {
          button.setAttribute('aria-pressed', String(this.selected[button.dataset.filterKey] === button.dataset.filterValue));
        });
        this.status.textContent = this.dataset.countLabel.replace('[shown]', String(shown)).replace('[total]', String(this.cards.length));
        this.empty.hidden = shown !== 0;
        this.reset.hidden = this.selected.city === '*' && this.selected.type === '*';
      }
      disconnectedCallback() {
        if (this.filterController) this.filterController.abort();
        this.filterController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["abz-visual-process"] && !Shopify.designMode) return;
  try {
    
class AbzVisualProcess extends HTMLElement{
connectedCallback(){
if(this.active)return;this.active=true;
this.cards=[...this.querySelectorAll('.vp-card')];this.button=this.querySelector('.vp-replay');
this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');
if(this.motion.matches)return;
this.classList.add('vp-ready');
this.replay=()=>{this.cards.forEach(c=>c.classList.remove('is-drawn'));this.frame=requestAnimationFrame(()=>{this.frame=requestAnimationFrame(()=>this.cards.forEach(c=>c.classList.add('is-drawn')))});};
this.button.hidden=false;this.button.addEventListener('click',this.replay);
if('IntersectionObserver' in window){this.observer=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-drawn');this.observer.unobserve(e.target);}});},{threshold:.2});this.cards.forEach(c=>this.observer.observe(c));}else{this.cards.forEach(c=>c.classList.add('is-drawn'));}
}
disconnectedCallback(){this.observer?.disconnect();if(this.frame)cancelAnimationFrame(this.frame);if(this.button&&this.replay)this.button.removeEventListener('click',this.replay);this.active=false;}
}
if(!customElements.get('abz-visual-process'))customElements.define('abz-visual-process',AbzVisualProcess);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
